export default __webpack_public_path__ + "static/media/phrases.c60a1c01.svg";